export default __webpack_public_path__ + "static/media/10.5c636ad4.jpg";